import { useLocation } from 'react-router';

import { appendSignupParams } from '@/auth/utils/signupParams';
import Button from '@/componentsv2/Button';

// The dialog's aria-labelledby while this panel replaces the step.
export const SIGN_IN_REQUIRED_TITLE_ID = 'self-service-smb-sign-in-title';

interface SignInRequiredStepProps {
  message: string;
}

// ENG-6106: terminal panel for a session the api refused mid-funnel until the
// user sets up MFA at login, or one that ended under a step. Same copy and
// round-trip as AccountStep's "Finish setup" screen, so campaign params
// survive the login (ENG-5527).
export function SignInRequiredStep({ message }: SignInRequiredStepProps): JSX.Element {
  const { search } = useLocation();
  const loginHref = `/login?next=${encodeURIComponent(
    appendSignupParams('/signup/customer', search)
  )}`;
  return (
    <div className="flex flex-col items-start gap-16 px-24 py-24">
      <header>
        <h2 id={SIGN_IN_REQUIRED_TITLE_ID} className="text-24 font-bold text-on-surface">
          Finish setup
        </h2>
        <p className="mt-8 text-14 text-on-surface-muted">{message}</p>
      </header>
      <Button size="large" to={loginHref}>
        Sign in to continue
      </Button>
    </div>
  );
}
